import CheckBox from './src/CheckBox'

CheckBox.install = function (Vue) {
    Vue.component(CheckBox.name, CheckBox);
};

export default CheckBox;